import { call, put, takeLatest, take, select } from 'redux-saga/effects';
import { chat, toast, loading, modal, serviceRequest, utils } from '../types';
import iceberg_apis from '../iceberg_apis';
import scogo_apis from '../scogo_apis';
import { chatType, CurrentOpenedChatTyoeTab } from '../pages/chat/ChatController';
import { uploadFileToS3WithSignedUrlNew } from '../utils/common';
import { chats } from '../router/roleWisePageRoute';

export function* getChats(action) {
    const { page = 1, limit = 25, query, dropdown, type, show_mentioned, is_active } = action.payload;
    const queryParams = { page, type, is_active };
    if (query) queryParams.q = query;
    queryParams.offset = (page - 1) * limit;
    queryParams.limit = limit;
    if (show_mentioned) queryParams.show_mentioned = show_mentioned;
    try {
        if (page === 1) {
            yield put({ type: loading.SET_CHAT_LIST_LOADING, payload: true });
        } else {
            yield put({ type: loading.SET_NEXT_CHAT_LIST_LOADING, payload: true });
        }
        const response = yield call(iceberg_apis.chats.get, {}, {}, queryParams);
        if (response.status === 200) {
            if (dropdown) {
                const d = response.data.data.map((item) => ({
                    label: item.name,
                    value: item.id,
                    key: item.id,
                }));
                yield put({ type: chat.GET_CHATS_DROPDOWN_SUCCESS, payload: { data: d } });
            } else {
                if (type === chatType.TICKET) {
                    const ids = response.data.data.map((item) => item.id);
                    if (ids.length > 0) {
                        yield put({ type: serviceRequest.GET_SERVICE_REQUEST_LIST_REQUEST, payload: { payload: { id: ids.join(','), limit: ids.length }, source: 'ticket_chat', callCountApi: false } });
                    }
                }
                yield put({ type: chat.GET_CHATS_SUCCESS, payload: { page, data: response.data.data, metaData: response?.data?.metadata } });
            }
        }
    } catch (error) {
        console.log('error:', error);
    } finally {
        if (page === 1) {
            yield put({ type: loading.SET_CHAT_LIST_LOADING, payload: false });
        } else {
            yield put({ type: loading.SET_NEXT_CHAT_LIST_LOADING, payload: false });
        }
    }
}

export function* createChat(action) {
    const { payload, onSuccess = () => { }, formName, teams } = action.payload;
    if (payload.icon) {
        const requestBody = {
            files: [{
                name: payload.icon.name,
                mime_type: payload.icon.type,
                size: payload.icon.size
            }],
            purpose: 'CHAT',
            chat_id: ''
        };

        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });

        const uploadResponse = yield call(scogo_apis.user.postImageUrl, {}, {}, {}, requestBody);
        if (uploadResponse?.status === 201 && uploadResponse?.data?.data?.postUrls) {
            const uploadedData = uploadResponse.data.data.postUrls;
            const postUrls = uploadResponse.data.data.postUrls;
            const iconFile = payload.icon;

            yield Promise.all([
                (async () => {
                    const f = postUrls.find(({ name }) => name === iconFile.name);
                    if (!f) {
                        console.error(`No signed URL found for file: ${iconFile.name}`);
                        return;
                    }
                    const body = {
                        'Content-Type': f.mimeType,
                        'key': f.payload.key,
                        ...(f.payload.acl ? { 'acl': f.payload.acl } : {}),
                        'X-Amz-Date': f.payload.date,
                        'X-Amz-Algorithm': f.payload.algorithm,
                        'x-amz-meta-uuid': f.payload.uuid,
                        'X-Amz-Credential': f.payload.credential,
                        'Policy': f.payload.policy,
                        'X-Amz-Signature': f.payload.signature,
                    };
                    try {
                        await uploadFileToS3WithSignedUrlNew(f.postUrl, iconFile, body);
                        console.log(`File uploaded successfully: ${iconFile.name}`);
                    } catch (uploadError) {
                        console.error(`Error uploading file ${iconFile.name}:`, uploadError);
                    }
                })()
            ]);
            payload.icon = uploadedData[0].fileUrl;
        }
    };

    try {
        const response = yield call(iceberg_apis.chats.create, {}, {}, {}, payload);

        if (response.status === 201) {
            yield put({ type: chat.GET_CHATS_REQUEST, payload: { page: 1, limit: 25, query: '', dropdown: false, type: 'GROUP,SINGLE' } });
            if (!teams) {
                yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: 'Chat created successfully' } });
            }

            onSuccess({ chatId: response.data.id });
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages[0] } });
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });

};

export function* getChatById(action) {
    const { id, buttonName } = action.payload;

    try {
        const response = yield call(iceberg_apis.chats.getById, {}, { id }, {});
        if (response.status === 200) {
            yield put({ type: chat.GET_MEMBER_IN_CHAT_REQUEST, payload: { id, limit: 100 } });
            yield put({ type: chat.GET_CHAT_BY_ID_SUCCESS, payload: { data: response.data } });
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages[0] || 'Something went wrong' } });
        if (buttonName) {
            yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName: buttonName, isLoading: false } });
        }
    }
}
export function* deleteChat(action) {
    const { } = action.payload;
    try {
        const response = yield call(iceberg_apis.chats.delete, {}, {}, {});
        if (response.status === 201) {

        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
        }
    } catch (error) {
        console.log('error:', error);
    }
}
export function* getMembersInChat(action) {
    const { id } = action.payload;
    try {
        const response = yield call(iceberg_apis.chats.getMembers, {}, { id }, {}, { users: [id] });
        if (response.status === 200) {
            yield put({ type: chat.GET_MEMBER_IN_CHAT_SUCCESS, payload: { data: response?.data, id } });
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
        }
    } catch (error) {
        console.log('error:', error);
    }
}
export function* removeMembersInChat(action) {
    const { id, users } = action.payload;
    try {

        const response = yield call(iceberg_apis.chats.removeMembers, {}, { id }, {}, { users });
        if (response.status === 200) {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: 'Member removed successfully' } });
            yield put({ type: modal.CLOSE_MODAL })
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages[0] || 'Something went wrong' } });
    }
}
export function* updateMembersInChat(action) {
    const { id } = action.payload;
    try {
        const response = yield call(iceberg_apis.chats.updateMemberRole, {}, { id }, {});
        if (response.status === 201) {

        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
        }
    } catch (error) {
        console.log('error:', error);
    }
}
export function* getChatMessages(action) {
    const { id, q, limit = 25, target_message_id, direction, onSuccess, cursor, source } = action.payload;

    try {
        const queryParams = { limit };
        if (q) queryParams.q = q;
        if (target_message_id) queryParams.target_message_id = target_message_id;
        if (cursor) queryParams.cursor = cursor;
        if (!target_message_id && direction) queryParams.direction = direction;

        if (source === 'search') {
            yield put({ type: loading.SET_SEARCH_MESSAGE_LOADING, payload: true });
        } else if (cursor && direction) {
            yield put({ type: loading.SET_NEXT_CHAT_MESSAGES_LOADING, payload: true });
        } else {
            yield put({ type: loading.SET_CHAT_MESSAGES_LOADING, payload: true });
        }

        const response = yield call(iceberg_apis.messages.list, {}, { id }, queryParams);

        if (response.status === 200) {
            yield put({
                type: chat.GET_CHAT_MESSAGES_SUCCESS,
                payload: {
                    data: Array.isArray(response.data.data) ? response.data.data.reverse() : response.data.data,
                    id,
                    isSearch: !!q,
                    reset: target_message_id ? true : false,
                    direction,
                    metaData: response.data.metadata,
                    target_message_id,
                    cursor
                }
            });

            if (onSuccess && typeof onSuccess === 'function') onSuccess();
        } else {
            yield put({
                type: toast.SEND_TOAST,
                payload: { status: 'danger', message: 'Something went wrong' }
            });
        }

    } catch (error) {
        console.log('error:', error);
    } finally {
        if (source === 'search') {
            yield put({ type: loading.SET_SEARCH_MESSAGE_LOADING, payload: false });
        } else if (cursor && direction) {
            yield put({ type: loading.SET_NEXT_CHAT_MESSAGES_LOADING, payload: false });
        } else {
            yield put({ type: loading.SET_CHAT_MESSAGES_LOADING, payload: false });
        }
    }
}

export function* sendChatMessages(action) {
    const { id, payload } = action.payload;

    try {
        if (payload.medias && payload.medias.length > 0) {
            try {
                const files = Array.from(payload.medias);
                const requestBody = {
                    files: files.map(({ file }) => ({
                        name: file?.name || 'unknown',
                        mime_type: file?.type || 'application/octet-stream',
                        size: file?.size || 0
                    })),
                    purpose: 'CHAT',
                    chat_id: id,
                };

                const uploadResponse = yield call(scogo_apis.user.postImageUrl, {}, {}, {}, requestBody);
                if (uploadResponse?.status === 201 && uploadResponse?.data?.data?.postUrls) {
                    const uploadedData = uploadResponse.data.data.postUrls;

                    yield Promise.all(
                        files.map(async ({ file }, index) => {
                            try {
                                const f = uploadedData.find(({ name }) => name === file?.name);
                                if (!f) {
                                    console.log(`No signed URL found for file: ${file?.name || 'unknown'}`);
                                    return;
                                }

                                const body = {
                                    'Content-Type': f.mimeType || 'application/octet-stream',
                                    'key': f.payload?.key || '',
                                    ...(f.payload?.acl ? { 'acl': f.payload.acl } : {}),
                                    'X-Amz-Date': f.payload?.date || '',
                                    'X-Amz-Algorithm': f.payload?.algorithm || '',
                                    'x-amz-meta-uuid': f.payload?.uuid || '',
                                    'X-Amz-Credential': f.payload?.credential || '',
                                    'Policy': f.payload?.policy || '',
                                    'X-Amz-Signature': f.payload?.signature || '',
                                };

                                await uploadFileToS3WithSignedUrlNew(f.postUrl, file, body);
                            } catch (uploadError) {
                                console.log(`Error uploading file ${file?.name || 'unknown'}:`, uploadError);
                            }
                        })
                    );

                    payload.medias = uploadedData.map((elem) => {
                        const findFile = files.find(({ file }) => file?.name === elem.name);
                        return {
                            url: elem.fileUrl || '',
                            name: elem.name || 'unknown',
                            mime_type: elem.mimeType || 'application/octet-stream',
                            caption: findFile?.caption || '',
                            size: findFile?.size || 0
                        }
                    });
                }
            } catch (mediaError) {
                console.log('Error processing media files:', mediaError);
                // Continue with sending the message without media if there's an error
                payload.medias = [];
            }
        }

        const response = yield call(iceberg_apis.messages.send, {}, { id }, {}, payload);
        if (response?.status === 201) {
            yield put({ type: chat.SEND_MESSAGE_SUCCESS, payload: { ref: `${id}-media` } });
            try {
                const lastDiv = document.getElementById('last_element_after_messages');
                if (lastDiv) {
                    lastDiv.scrollIntoView({ behavior: 'smooth' });
                }
            } catch (scrollError) {
                console.log('Error scrolling to last message:', scrollError);
            }
        } else {
            console.log('Message sending response not successful:', response);
        }
    } catch (error) {
        console.log('Error sending chat message:', error);
        yield put({
            type: toast.SEND_TOAST,
            payload: {
                status: 'danger',
                message: 'Failed to send message. Please try again.'
            }
        });
    }
}
export function* addMemberInChat(action) {
    const { id, payload, formName } = action.payload;

    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(iceberg_apis.chats.addMembers, {}, { id }, {}, payload);

        if (response.status === 200) {
            yield put({ type: modal.CLOSE_MODAL })
            // yield put({ type: chat.GET_MEMBER_IN_CHAT_SUCCESS, payload: response.data.data });
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages[0] || 'Something went wrong' } });
        console.log('error:', error);
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export function* openChatModal(action) {
    const { chatId, buttonName, isRightClick, teams, defaulOpentChecklist, openInBackground = false } = action.payload;
    if (isRightClick) {
        window.open(`/chats/${chatId}?tab=alltickets`, '_blank');
        return;
    }
    try {
        const openedChatBoxData = yield select((state) => state.chat.openedChatBoxData);
        const findChat = openedChatBoxData.find((item) => item.chatId === chatId);
        if (findChat) {
            if (!openInBackground && findChat.openInBackground) {
                yield put({ type: chat.TAKE_CHAT_AT_FIRST_POSITION, payload: findChat });
            }
            return;
        }
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName: buttonName, isLoading: true } });
        yield put({ type: chat.GET_CHAT_BY_ID_REQUEST, payload: { id: chatId, buttonName } });
        const chatDetails = yield take([chat.GET_CHAT_BY_ID_SUCCESS]);
        if (chatDetails.payload.type === chatType.TICKET) {
            yield put({ type: serviceRequest.GET_SERVICE_REQUEST_BY_ID_REQUEST, payload: { ticketId: chatDetails.payload.id } });
            yield take([serviceRequest.GET_SERVICE_REQUEST_BY_ID_SUCCESS]);
        }
        yield put({ type: chat.OPEN_CHAT_MODAL_SUCCESS, payload: { chatId, defaulOpentChecklist, openInBackground } });
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages[0] || 'Something went wrong' } });
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName: buttonName, isLoading: false } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName: buttonName, isLoading: false } });
    }
}

export function* getChatUsers(action) {
    const { limit, page, org_id, q } = action.payload;
    const queryParams = { limit, page, org_id };
    if (q) queryParams.q = q;
    try {
        if (page === 1) {
            yield put({ type: loading.SET_CHAT_USER_LIST_LOADING, payload: true });
        } else {
            yield put({ type: loading.SET_NEXT_CHAT_USER_LIST_LOADING, payload: true });
        }
        const response = yield call(scogo_apis.user.getUsersList, {}, {}, queryParams, {});
        if (response.status === 200) {
            const data = response.data.data.map((item) => ({
                key: item.id,
                value: item.id,
                label: `${item.full_name}`,
                user: item,
            }));
            yield put({ type: chat.GET_CHAT_USERS_SUCCESS, payload: { data, page } });
        }
    } catch (error) {
        console.log('error:', error)
    } finally {
        if (page === 1) {

            yield put({ type: loading.SET_CHAT_USER_LIST_LOADING, payload: false });
        } else {
            yield put({ type: loading.SET_NEXT_CHAT_USER_LIST_LOADING, payload: false });

        }
    }
};


export function* getChatMedia(action) {
    const { id, type, limit = 25, page = 1, editCustomerReport } = action.payload;
    try {
        if (page > 1) {
            yield put({ type: loading.SET_NEXT_CHAT_MEDIA_LOADING, payload: true });
        } else {
            yield put({ type: loading.SET_CHAT_MEDIA_LOADING, payload: true });
        }
        const response = yield call(iceberg_apis.chats.getMedia, {}, { id }, { type, limit, page });
        if (response.status === 200) {
            yield put({ type: chat.GET_CHAT_MEDIA_SUCCESS, payload: { data: response?.data, id, page, type } });

        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
        }

    } catch (error) {
        console.log('error:', error);
    } finally {
        if (page > 1) {
            yield put({ type: loading.SET_NEXT_CHAT_MEDIA_LOADING, payload: false });
        } else {
            yield put({ type: loading.SET_CHAT_MEDIA_LOADING, payload: false });
        }
    }
}
export function* getCustomerMedia(action) {
    const { id, } = action.payload;
    try {
        yield put({ type: loading.SET_GET_CUSTOMER_CHAT_MEDIA_LOADING, payload: true });
        const response = yield call(iceberg_apis.chats.getMedia, {}, { id }, {});
        if (response.status == 200) {
            yield put({ type: chat.CUSTOMER_MEDIA_SUCCESS, payload: { data: response?.data } })
        }
    }
    catch (error) {
        console.log('Error', error)
    } finally {
        yield put({ type: loading.SET_GET_CUSTOMER_CHAT_MEDIA_LOADING, payload: false });
    }
}
export function* editChatMessage(action) {
    const { id, payload, messageId } = action.payload;
    try {
        const response = yield call(iceberg_apis.messages.update, {}, { id, messageId }, {}, payload);
        yield put({ type: chat.EDITING_MESSAGE, payload: { messageId, id } });
        if (response.status === 200) {
            yield put({ type: chat.EDIT_CHAT_MESSAGE_SUCCESS, payload: { data: response.data.data, id } });
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
        }
    } catch (error) {
        console.log('error:', error);
    }
}
export function* deleteChatMessage(action) {
    const { id, messageId } = action.payload;
    try {
        const response = yield call(iceberg_apis.messages.delete, {}, { id, messageId }, {});
        if (response.status === 200) {
            yield put({ type: modal.CLOSE_MODAL })
            yield put({ type: chat.DELETE_CHAT_MESSAGE_SUCCESS, payload: { data: response.data, id } });
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
        }
    } catch (error) {
        console.log('error:', error);
    }
}
export function* updateChatById(action) {
    const { id, payload } = action.payload;
    try {
        if (payload.icon) {
            const requestBody = {
                files: [{
                    name: payload.icon.name,
                    mime_type: payload.icon.type,
                    size: payload.icon.size
                }],
                purpose: 'CHAT',
                chat_id: ''
            };

            const uploadResponse = yield call(scogo_apis.user.postImageUrl, {}, {}, {}, requestBody);
            if (uploadResponse?.status === 201 && uploadResponse?.data?.data?.postUrls) {
                const uploadedData = uploadResponse.data.data.postUrls;
                const postUrls = uploadResponse.data.data.postUrls;
                const iconFile = payload.icon;

                yield Promise.all([
                    (async () => {
                        const f = postUrls.find(({ name }) => name === iconFile.name);
                        if (!f) {
                            console.error(`No signed URL found for file: ${iconFile.name}`);
                            return;
                        }
                        const body = {
                            'Content-Type': f.mimeType,
                            'key': f.payload.key,
                            ...(f.payload.acl ? { 'acl': f.payload.acl } : {}),
                            'X-Amz-Date': f.payload.date,
                            'X-Amz-Algorithm': f.payload.algorithm,
                            'x-amz-meta-uuid': f.payload.uuid,
                            'X-Amz-Credential': f.payload.credential,
                            'Policy': f.payload.policy,
                            'X-Amz-Signature': f.payload.signature,
                        };
                        try {
                            await uploadFileToS3WithSignedUrlNew(f.postUrl, iconFile, body);
                            console.log(`File uploaded successfully: ${iconFile.name}`);
                        } catch (uploadError) {
                            console.error(`Error uploading file ${iconFile.name}:`, uploadError);
                        }
                    })()
                ]);
                payload.icon = uploadedData[0].fileUrl;
            }
        };

        const response = yield call(iceberg_apis.chats.update, {}, { id }, {}, payload);
        if (response.status === 200) {
            yield put({ type: chat.UPDATE_CHAT_BY_ID_SUCCESS, payload: { data: response.data } });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: 'Chat updated successfully' } });
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
        }
    } catch (error) {
        console.log('error:', error);
    }
};

export function* addTeamsToChat(action) {
    const { id, teamIds, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(iceberg_apis.chats.addTeamsToChat, {}, { id }, {}, { team_ids: teamIds });
        if (response.status === 201) {
            yield put({ type: chat.GET_CHAT_BY_ID_REQUEST, payload: { id } });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message ? response.data.message : 'Team added to chat successfully' } });
            yield put({ type: modal.CLOSE_MODAL })
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
        }
    } catch (error) {
        console.log('error:', error);
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }

}
export function* removeTeamsFromChat(action) {
    const { id, teamIds, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(iceberg_apis.chats.removeTeamsFromChat, {}, { id }, {}, { team_ids: teamIds });
        if (response.status === 201) {
            yield put({ type: chat.REMOVE_TEAMS_FROM_CHAT_SUCCESS, payload: { id, teamIds } });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message ? response.data.message : 'Team removed from chat successfully' } });
            yield put({ type: modal.CLOSE_MODAL })
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
        }

    } catch (error) {
        console.log('error:', error);
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}


export function* getChatLogs(action) {
    const { id } = action.payload;
    try {
        yield put({ type: loading.SET_CHAT_LOGS_LOADING, payload: true });
        const response = yield call(iceberg_apis.chats.getChatLogs, {}, { id }, {});
        if (response.status === 200) {
            yield put({ type: chat.GET_CHAT_LOGS_SUCCESS, payload: { data: response.data, id } });
        }
    } catch (error) {
        console.log('error:', error);
    } finally {
        yield put({ type: loading.SET_CHAT_LOGS_LOADING, payload: false });
    }
}
export function* readMessage(action) {
    const { id } = action.payload;
    try {
        const response = yield call(iceberg_apis.chats.readMessage, {}, { id }, {});
        if (response.status === 201) {
            yield put({ type: chat.READ_MESSAGE_SUCCESS, payload: { id } });
        }
    } catch (error) {
        console.log('error:', error);
    }
}

export function* updateMediaStatus(action) {
    const { id, payload, formName, chat_id, message_id } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.media.updateStatus, {}, { id }, {}, payload);
        if (response.status === 201) {
            const newLoggedUserData = yield select((state) => state.auth.newLoggedUserData);
            yield put({
                type: chat.UPDATE_MEDIA_STATUS_SUCCESS, payload: {
                    chat_id, message_id, attachment_id: id, is_approved: payload.is_approved, is_rejected: payload.is_rejected, user: {
                        id: newLoggedUserData.user.id,
                        display_name: newLoggedUserData.user.display_name
                    }
                }
            });
        }
    } catch (error) {
        console.log('error:', error);
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export function* tranformMedia(action) {
    const { attachmentId, instructions } = action.payload;
    try {
        yield put({ type: loading.TRANSFORN_ATTACHMENT_LOADING, payload: true });
        const payload = { instructions }
        const response = yield call(scogo_apis.media.transform, {}, { id: attachmentId }, {}, payload);
        if (response.status === 201) {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message ? response.data.message : 'Media Transformed' } });
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: response.data?.message || 'Something went wrong' } });
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.TRANSFORN_ATTACHMENT_LOADING, payload: false });
    }
}
export function* chatNotification(action) {
    const { id, mode } = action.payload;
    try {
        yield put({ type: loading.SET_CHANGE_NOTIFICATION_SETTINGS_LOADING, payload: true });
        const response = yield call(iceberg_apis.chats.chatNotification, {}, { id }, {}, { mode });
        if (response.status === 200) {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message } });
            yield put({ type: chat.CHAT_NOTIFICATION_SUCCESS, payload: { id, mode } });
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.SET_CHANGE_NOTIFICATION_SETTINGS_LOADING, payload: false });
    }
}


export function* getChatAndSetToFirst(action) {
    const { id } = action.payload;
    const chats = yield select((state) => state.chat.chats);
    const findChat = chats.find(chat => chat.id === id);
    if (findChat) return;

    try {
        const chatData = yield call(iceberg_apis.chats.getById, {}, { id }, {});
        const { rootTab } = CurrentOpenedChatTyoeTab();
        const types = {
            GROUP: 'groups',
            SINGLE: "groups",
            TICKET: 'tickets',
            HELP: 'helpopen'
        };

        if (rootTab.path !== types[chatData.data.type]) return;
        const chatMessages = yield call(iceberg_apis.messages.list, {}, { id }, { limit: 25 });
        if (chatData.status === 200 && chatMessages.status === 200) {
            yield put({ type: chat.GET_MEMBER_IN_CHAT_REQUEST, payload: { id, limit: 100 } });
            yield put({ type: chat.GET_CHAT_BY_ID_SUCCESS, payload: { data: chatData.data, updateListAtFirst: true } });
            if (chatData.data.type === chatType.TICKET) {
                yield put({ type: serviceRequest.GET_SERVICE_REQUEST_BY_ID_REQUEST, payload: { ticketId: id } });
                yield take([serviceRequest.GET_SERVICE_REQUEST_BY_ID_SUCCESS]);
            }
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'warning', message: 'Some Messages are not loaded properly, Please Reload to see the new messages.' } });
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'warning', message: 'Some Messages are not loaded properly, Please Reload to see the new messages.' } });
    }
}

export function* closeChatRequest(action) {
    const { id, formName, navigate } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.chat.closeChat, {}, { id }, {}, {});
        if (response.status === 201) {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response?.data?.message || 'Chat closed successfully' } });
            yield put({ type: chat.CLOSE_CHAT_SUCCESS, payload: { id } });
            navigate(`${chats.path}?tab=helpclosed`);
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export function* getUsersForMentions(action) {
    const { query } = action.payload;
    try {
        const response = yield call(scogo_apis.user.getUsersList, {}, {}, { q: query, org_id: 'SCOGO' }, {});
        if (response.status === 200) {
            yield put({ type: chat.GET_USERS_FOR_MENTIONS_SUCCESS, payload: response.data.data });
        }
    } catch (error) {
        console.log('error:', error);
    }
}


export default function* chatSaga() {
    yield takeLatest(chat.GET_CHATS_REQUEST, getChats);
    yield takeLatest(chat.CREATE_CHAT_REQUEST, createChat);
    yield takeLatest(chat.GET_CHAT_BY_ID_REQUEST, getChatById);
    yield takeLatest(chat.DELETE_CHAT_REQUEST, deleteChat);
    yield takeLatest(chat.GET_MEMBER_IN_CHAT_REQUEST, getMembersInChat);
    yield takeLatest(chat.REMOVE_MEMBER_IN_CHAT_REQUEST, removeMembersInChat);
    yield takeLatest(chat.UPDATE_MEMBER_ROLE_IN_CHAT_REQUEST, updateMembersInChat);
    yield takeLatest(chat.GET_CHAT_MESSAGES_REQUEST, getChatMessages);
    yield takeLatest(chat.SEND_MESSAGE_REQUEST, sendChatMessages);
    yield takeLatest(chat.ADD_MEMBER_IN_CHAT_REQUEST, addMemberInChat);
    yield takeLatest(chat.OPEN_CHAT_MODAL_REQUEST, openChatModal);
    yield takeLatest(chat.GET_CHAT_USERS_REQUEST, getChatUsers);
    yield takeLatest(chat.GET_CHAT_MEDIA_REQUEST, getChatMedia);
    yield takeLatest(chat.EDIT_CHAT_MESSAGE_REQUEST, editChatMessage);
    yield takeLatest(chat.DELETE_CHAT_MESSAGE_REQUEST, deleteChatMessage);
    yield takeLatest(chat.UPDATE_CHAT_BY_ID_REQUEST, updateChatById)
    yield takeLatest(chat.ADD_TEAMS_TO_CHAT_REQUEST, addTeamsToChat)
    yield takeLatest(chat.REMOVE_TEAMS_FROM_CHAT_REQUEST, removeTeamsFromChat)
    yield takeLatest(chat.GET_CHAT_LOGS_REQUEST, getChatLogs)
    yield takeLatest(chat.READ_MESSAGE_REQUEST, readMessage)
    yield takeLatest(chat.UPDATE_MEDIA_STATUS_REQUEST, updateMediaStatus)
    yield takeLatest(chat.CHAT_NOTIFICATION_REQUEST, chatNotification)
    yield takeLatest(chat.GET_CHAT_AND_SET_AT_FIRST, getChatAndSetToFirst)
    yield takeLatest(chat.CLOSE_CHAT_REQUEST, closeChatRequest)
    yield takeLatest(chat.GET_CUSTOMER_MEDIA_REQUEST, getCustomerMedia)
    yield takeLatest(utils.TRANSFORN_ATTACHMENT_REQUEST, tranformMedia)
    yield takeLatest(chat.GET_USERS_FOR_MENTIONS_REQUEST, getUsersForMentions)
}
